import { AfterContentInit, Component, ContentChildren, EventEmitter, Output, QueryList } from '@angular/core';
import { LaftStepComponent } from '../laft-step/laft-step.component';

@Component({
  selector: 'app-laft-stepper',
  templateUrl: './laft-stepper.component.html',
  styleUrls: ['./laft-stepper.component.scss'],
})
export class LaftStepperComponent implements AfterContentInit {
  @ContentChildren(LaftStepComponent) steps: QueryList<LaftStepComponent>;
  @Output() submit = new EventEmitter();
  @Output() saveIncomplete = new EventEmitter();
  totalSteps;
  currentStepIndex = 1;
  formValue;

  constructor() {}

  ngAfterContentInit(): void {
    this.totalSteps = this.steps.length;
    this.navigation();

    this.steps.forEach((item: LaftStepComponent, index) => {
      item.stepContent?.onNext?.subscribe(x => {
        this.next(x);
      });
      item.stepContent?.onPrevious.subscribe(x => {
        this.previous();
      });
    });
  }

  navigation() {
    this.steps.forEach((item: LaftStepComponent, index: number) => {
      if (index + 1 == this.currentStepIndex) {
        item.active = true;
      } else {
        item.active = false;
      }
    });
  }

  next(data) {
    this.setForm(data);
    if (this.currentStepIndex != this.totalSteps) {
      this.currentStepIndex++;
      this.navigation();
    } else {
      this.submit.emit(this.formValue);
    }
  }

  previous() {
    if (this.currentStepIndex != 1) {
      this.currentStepIndex--;
      this.navigation();
    }
  }

  setForm(data) {
    if (data !== undefined) {
      if (this.formValue !== undefined) {
        let values = this.formValue;
        let newValues = Object.assign(values, data);
        this.formValue = newValues;
      } else {
        this.formValue = Object.assign({}, data);
      }

      if (this.currentStepIndex == 2) {
        this.setIncomplete(this.formValue);
      }
    }
  }

  setIncomplete(data) {
    this.saveIncomplete.emit(data);
  }
}
